// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3OQdP","signatureBlock":"Footer_signatureBlock__3ksBq","signature":"Footer_signature__AGiwg"};